module.exports = __webpack_public_path__ + "img/thumbnail_Cougar_m_normal.6ec1c169.png";